const { getElement, getElements } = window.BAO.Utils

class CardSwitcher extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'click', this.handleClick.bind(this))
  }

  handleClick (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!triggerEl) return

    const style = triggerEl.dataset.style
    const attribute = triggerEl.dataset.attribute

    if (!attribute || !style) return

    const property = `${attribute}Style`
    window.theme[property] = style

    const component = getElement('algolia-instant-search-widget')
    component.dataset[property] = style

    this.updateTriggerState(attribute, style)
    this.setCartAttribute(`collection_${attribute}_style`, style)

    if (attribute === 'card') {
      this.resetExternalProductCardImageScroll()
    }
  }

  updateTriggerState (attribute, style) {
    const elements = getElements(this.els?.trigger?.selector)
    if (!elements.length) return

    elements.forEach((triggerEl) => {
      if (triggerEl.dataset.attribute !== attribute) return

      const isActive = triggerEl.dataset.style === style
      triggerEl.setAttribute('aria-pressed', isActive)
    })
  }

  resetExternalProductCardImageScroll () {
    const gridEl = this.externalEls?.grid?.element

    if (!gridEl) return

    gridEl
      .querySelectorAll('[data-card-switcher-images]')
      .forEach((imagesEl) => {
        imagesEl.style.scrollBehavior = 'auto'
        imagesEl.scrollLeft = 0
        imagesEl.style.scrollBehavior = ''
      })
  }

  setCartAttribute (attributeKey, attributeValue) {
    // eslint-disable-next-line compat/compat
    return fetch(window.routes.cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }
}

if (!customElements.get('card-switcher')) {
  customElements.define('card-switcher', CardSwitcher)
}
